import { AllTypes } from ".";

export function deserializeMessage(msg: string) {
	let data = null;

	try {
		data = JSON.parse(msg) as AllTypes;
	} catch (e: any) {
		if (e instanceof SyntaxError) {
			return null;
		}
		throw e;
	}

	if (!data || !data.type) {
		console.log("Message data did not contain type attribute", data);
		return null;
	}

	return data;
}

export const createSubscriberAndNotifier =
	(sender: (msg: string) => void) =>
	<T extends AllTypes>(type: T["type"]) => {
		let count: number = 0;
		const myMap = new Map<number, (msg: T) => void>();

		return {
			type,
			notify: (msg: T) => sender(JSON.stringify(msg)),
			_notifyOnReceiveMessage: (msg: AllTypes) => {
				if (msg.type === type) {
					myMap.forEach(fn => fn(msg as T));
				}
			},
			subscribe: (cb: (msg: T) => void) => {
				const instance = count++;
				myMap.set(instance, cb);

				return () => {
					myMap.delete(instance);
				};
			}
		};
	};
